export default "{\n    \"dismissButton\": \"Got it!\"\n}\n"